import { Controller } from "@hotwired/stimulus"

// Manages the invitation request form: reCAPTCHA validation and submit button loading state.
export default class extends Controller {
  static targets = ["submitLabel", "submitSpinner", "submitButton"]
  static values  = { recaptchaEnabled: Boolean }

  connect() {
    if (this.recaptchaEnabledValue) {
      // Namespaced event so disconnect() can cleanly remove only this listener
      $('#invitation_form_modal').on('shown.bs.modal.invitation-request', () => {
        responsiveRecaptcha()
      })
    }
  }

  disconnect() {
    $('#invitation_form_modal').off('.invitation-request')
  }

  submit(event) {
    if (this.recaptchaEnabledValue && grecaptcha.getResponse() === '') {
      event.preventDefault()
      $('.g-recaptcha div div iframe').css('border', '1px solid #dc3545')
      return
    }
    this.#showSpinner()
  }

  // Called on ajax:error (network failures, 429, etc.)
  // Validation errors re-render the whole container, reconnecting the controller fresh.
  restoreButton() {
    this.submitButtonTarget.disabled = false
    this.submitLabelTarget.classList.remove('d-none')
    this.submitSpinnerTarget.classList.add('d-none')
  }

  #showSpinner() {
    this.submitButtonTarget.disabled = true
    this.submitLabelTarget.classList.add('d-none')
    this.submitSpinnerTarget.classList.remove('d-none')
  }
}
